export default {
    authenticationEndpoint: 'https://cliente.novida.co/api/authenticate',
    gestaoClientesApi: 'https://cliente.novida.co/api',
    gestaoLocalizacaoApi: 'https://api.novida.co/gestao/localizacao/api/v2',
    metricServerApi: 'https://api.novida.co/metrica/api',
    // authenticationEndpoint: 'http://localhost:8012/proxy/api/authenticate',
    // gestaoClientesApi: 'http://localhost:8012/proxy/api',
    // gestaoLocalizacaoApi: 'http://localhost:8013/proxy/api/v2',
    alcatrazApi: 'https://api.novida.co/gestao/tarefas'
}